import axios from 'axios';
import routes from '../routes/routes.json';
import { DateTime } from 'luxon';

export const setSessionData = (sessData) => {
  if (typeof (Storage) !== 'undefined') {
    localStorage.setItem('sessionData', JSON.stringify(sessData));
  }
}

export const createSession = (sessData) => {
  if (typeof (Storage) !== 'undefined') {
    localStorage.setItem('sessionStatus', true);
  }
  setSessionData(sessData);
}

export const sessionPlan = (plan) => {
  localStorage.setItem('logging_in_from_email', plan);
}

export const validateSession = (res) => {
  if (res.data.session && res.data.session != '') {
    let flag  = false ;
    flag = localStorage.getItem('logging_in_from_email');
    clearSession();
    if(flag)
    window.location.assign(routes.contentroutes.login + "?email=1");
    else
    window.location.assign(routes.contentroutes.login);
    return true;
  }
  return false;
}

export const validateChildSession = (res) => {
  if (res.data.session && res.data.session != '') {
    clearSession();
    window.location.assign('/');
    return true;
  }
  return false;
}

export const validateAdminSession = (res) => {
  if (res.data.session && res.data.session != '') {
    clearSession();
    window.location.assign(routes.adminroutes.main);
    return true;
  }
  return false;
}

export const clearSession = () => {
  // Get and update ack data before clearing
  const userEmail = getSessionData()?.user_email || '';
  const ackData = localStorage.getItem('child_update_prompt_info');
  let updatedAckData = ackData;
  if (ackData && userEmail) {
    try {
      const parsed = JSON.parse(ackData);
      if (parsed[userEmail]) {
        parsed[userEmail].sec_tracker = null;
        updatedAckData = JSON.stringify(parsed);
      }
    } catch (e) {
      console.error('Error parsing ack data:', e);
    }
  }
  localStorage.clear();
  if (updatedAckData) {
    localStorage.setItem('child_update_prompt_info', updatedAckData);
  }
}
export const sessionDataAPI = (callback) => {
  let csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  axios.defaults.headers.post['X-CSRF-Token'] = csrf_token;
  axios.post('/fetch/session/data').then((res) => {
    if (validateSession(res)) return;
    let serverError = res.data.error;
    if (serverError) {
      console.log(serverError);
    } else {
      createSession(res.data);
      callback();
    }
  }).catch((error) => {
    console.log(error);
  });
}

export const childSessionDataAPI = (callback) => {
  let csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  axios.defaults.headers.post['X-CSRF-Token'] = csrf_token;
  axios.post('/fetch/child/session/data').then((res) => {
    if (validateChildSession(res)) return;
    let serverError = res.data.error;
    if (serverError) {
      console.log(serverError);
    } else {
      createSession(res.data);
      callback();
    }
  }).catch((error) => {
    console.log(error);
  });
}

export const adminSessionDataAPI = (callback) => {
  let csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  axios.defaults.headers.post['X-CSRF-Token'] = csrf_token;
  axios.post('/fetch/admin/session/data').then((res) => {
    if (validateAdminSession(res)) return;
    let serverError = res.data.error;
    if (serverError) {
      console.log(serverError);
    } else {
      createSession(res.data);
      callback();
    }
  }).catch((error) => {
    console.log(error);
  });
}

export const checkSession = () => {
  let csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  axios.defaults.headers.post['X-CSRF-Token'] = csrf_token;
  axios.post('/fetch/session/validate').then((res) => {
    if (validateSession(res)) return;
    let serverError = res.data.error;
    if (serverError) {
      console.log(serverError);
    }
  }).catch((error) => {
    console.log(error);
  });
}

export const isSessionExpired = async () => {
  let csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  axios.defaults.headers.post['X-CSRF-Token'] = csrf_token;

  try {
    const res = await axios.post('/fetch/session/validate');
    if (res.data.session && res.data.session !== '') clearSession();
  } catch (error) {
    console.error('Error checking session status:', error);
  }
  
};

export const checkChildSession = () => {
  let csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  axios.defaults.headers.post['X-CSRF-Token'] = csrf_token;
  axios.post('/fetch/child/session/validate').then((res) => {
    if (validateChildSession(res)) return;
    let serverError = res.data.error;
    if (serverError) {
      console.log(serverError);
    }
  }).catch((error) => {
    console.log(error);
  });
}

export const checkAdminSession = () => {
  let csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  axios.defaults.headers.post['X-CSRF-Token'] = csrf_token;
  axios.post('/fetch/admin/session/validate').then((res) => {
    if (validateAdminSession(res)) return;
    let serverError = res.data.error;
    if (serverError) {
      console.log(serverError);
    }
  }).catch((error) => {
    console.log(error);
  });
}

export const setAdminSession = () => {
  const sessData = getSessionData();
  let csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  axios.defaults.headers.post['X-CSRF-Token'] = csrf_token;
  axios.post('/fetch/admin/login', { user_timezone: DateTime.local().zoneName, login_type: 'impersonate' }).then((res) => {
    let serverError = res.data.error;
    if (serverError) {
      console.log(serverError);
    } else {
      clearSession();
      createSession(res.data);
      window.location.assign(`https://${window.location.hostname}/v1/admin/support/accounts/user/${sessData.user_account_uuid}/account_settings`);
    }
  }).catch((error) => {
    console.log(error);
    window.location.assign(`https://${window.location.hostname}/v1/admin/support/accounts`);
  });
}

export const logoutUser = () => {
  const csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  axios.defaults.headers.post['X-CSRF-Token'] = csrf_token;
  axios.post('/fetch/logout').then((res) => {
    if (res.data.error) {
      console.log(res.data.error);
      return;
    }
    const userEmail = getSessionData()?.user_email || '';
    const ackData = localStorage.getItem('child_update_prompt_info');
    let updatedAckData = ackData;
    if (ackData && userEmail) {
      try {
        const parsed = JSON.parse(ackData);
        if (parsed[userEmail]) {
          parsed[userEmail].sec_tracker = null;
          updatedAckData = JSON.stringify(parsed);
          console.log('Reset sec_tracker for user:', userEmail);
        }
      } catch (e) {
        console.error('Error parsing ack data:', e);
      }
    }
    localStorage.clear();
    if (updatedAckData) localStorage.setItem('child_update_prompt_info', updatedAckData);
    window.location.assign('/');
  }).catch(error => console.log(error));
}

export const getSessionStatus = () => {
  return localStorage.sessionStatus;
}

export const getSessionData = () => {
  return (
    localStorage.sessionData ? JSON.parse(localStorage.sessionData) : undefined
  )
}

export const setSessionPaymentData = () => {
  window.localStorage.setItem("pending_purchase", true);
};

export const getSessionPaymentData = () => {
  return localStorage.pending_purchase
    ? localStorage.pending_purchase
    : undefined;
};

export const removeSessionPaymentData = () => {
  localStorage.removeItem("pending_purchase");
};

export const setChildDashboardVersionType = (dashboardVersionType) => {
  window.localStorage.setItem("dashboard_version_type", dashboardVersionType);
}

export const getChildDashboardVersionType = () => {
  return localStorage.dashboard_version_type
    ? localStorage.dashboard_version_type
    : 'old';
}